
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './personality.json';

const Personality = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Personality psychology, traits, and self-awareness vocabulary. B2 English exercises with grammar, vocab, and speaking practice."
            level="B2"
            title="Personality"
            image="/Images/argue4.webp"
            seoTitle="Free English Lesson Plans: Personality"
            seoDescription="Personality psychology, traits, and self-awareness vocabulary. B2 English exercises with grammar, vocab, and speaking practice."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default Personality;


